import { inject, Injectable } from '@angular/core';
import { DataReaderService } from '@core/lp/data-reader.service';
import { LpProjectSettings } from '@typings/lp/generated';

@Injectable({
  providedIn: 'root',
})
export class LpProjectSettingsService {
  readonly #dataReaderService = inject(DataReaderService);

  private settings: LpProjectSettings | undefined;

  public async getSettings(): Promise<LpProjectSettings> {
    if (this.settings) return this.settings;

    this.settings = (await this.#dataReaderService.getInstancesByType('ProjectSettings'))[0]; // TODO: handle multiple project settings

    return this.settings;
  }
}
